import { render, staticRenderFns } from "./PodcastsList.vue?vue&type=template&id=a628c6a4&scoped=true&"
import script from "./PodcastsList.vue?vue&type=script&lang=js&"
export * from "./PodcastsList.vue?vue&type=script&lang=js&"
import style0 from "./PodcastsList.vue?vue&type=style&index=0&id=a628c6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a628c6a4",
  null
  
)

export default component.exports